import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
// import ExpansionPanel from '@material-ui/core/ExpansionPanel';
// import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
// import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
// import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import './WorkoutDescription.css';

const TabContainer = (props) => {
  return (
    <Grid 
      container
      alignItems="flex-start"
      justify="center"
      className="pa4">
      <Grid 
        item
        sm={6}
        xs={12}
        className="children-container tl pr2">
        <Typography component="div" className="f-13">
          {props.children}
        </Typography>
      </Grid>
      <Grid 
        item
        sm={6}
        xs={12}
        className="tl f-13">
        {props.screenWidth > 600 &&
          <div>
            <h4 className="mt0 mb2">
              <Grid container alignItems="center">
                <Grid item>
                  <i className="fab fa-youtube mr1 f5 red"></i>
                </Grid>
                <Grid item>
                  EVENT OVERVIEW VIDEO
                </Grid>
              </Grid>
            </h4>
            <div className="videoWrapper">
              <iframe title="workout-description" src={'https://www.youtube.com/embed/' + props.videoRef} allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe>
            </div>
          </div>
        }
        <h4 className="mt2 mt3-ns mb2"><i className="far fa-sticky-note"></i>   NOTES</h4>
        <p className="mv0 lh-title">{props.notes}
          <br /><br />
          {props.example}
        </p>

        <a 
          className="db mv4 mt3-ns mb0-ns"
          target="_blank" 
          href={props.refSheet} 
          rel="noreferrer noopener">
          <Grid container alignItems="center">
            <Grid item>
              <i className="far fa-file-pdf mr1 f5"></i>
            </Grid>
            <Grid item>
              Full event details and standards
            </Grid>
          </Grid>
        </a>
        
        {props.screenWidth <= 600 &&
          <a 
            className="db mv4 mt3-ns mb0-ns"
            target="_blank" 
            href={'https://youtube.com/watch?v=' + props.videoRef} 
            rel="noreferrer noopener">
            <Grid container alignItems="center">
              <Grid item>
                <i className="fab fa-youtube mr1 f5 red"></i>
              </Grid>
              <Grid item>
                Event overview video
              </Grid>
            </Grid>
          </a>
        }
        <a 
          className="db mt2"
          target="_blank" 
          href={'https://btwb.com/rogue' + props.logId} 
          rel="noreferrer noopener">
          <Grid container alignItems="center">
            <Grid item>
              <i className="fas fa-mobile-alt mr1 f5 "></i>
            </Grid>
            <Grid item>
              Log your score on BTWB
            </Grid>
          </Grid>
        </a>
      </Grid>
    </Grid>
  );
}

class WorkoutDescription extends Component {
  constructor(props) {
    super(props)

    this.state = {
      workoutsOpened: 0,
      screenWidth: 0
    }

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({
      screenWidth: window.innerWidth
    });

    window.onresize = () => {
      this.setState({
        screenWidth: window.innerWidth
      });
    };
  }

  componentWillUnmount() {

  }

  handleChange(event, panel) {
    if (panel === this.state.workoutsOpened) panel = false;
    this.setState({
      workoutsOpened: panel
    })
  }


  render() {
    return(
      <div>
        <div className="mb4 bg-white ">
          <Paper>
            <Tabs 
              centered 
              value={this.state.workoutsOpened} 
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="primary">
              <Tab label="Event 1" />
              <Tab label="Event 2" />
              <Tab label="Event 3" />
              <Tab label="Event 4" />
            </Tabs>
          </Paper>
          <Grid
            container
            justify="center"
            alignItems="center"
            className="modal-header">
            <Grid
              item
              lg={6}
              md={7}
              sm={9}
              xs={12}
              className="mw7 mt1 center">
              {this.state.workoutsOpened === 0 && 
                <TabContainer 
                  videoRef={'Pwk-vQlLyAs'}
                  notes={'Event 1 is scored by handstand push-up reps. The leaderboard will display total reps completed followed by the 2k row tiebreak time.'}
                  example={'Ex: (25 reps [7:03])'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://www.roguefitness.com/theindex/wp-content/uploads/2019/04/Rogue-Invitational-Movement-Standards-Wod-1.pdf'}
                  logId={'1'}>
                  <h4><i className="fas fa-angle-double-right"></i>   AMReps 11 mins:</h4>
                  <p>Row 2000m</p>
                  <p>Max Rep HSPU w/ remaining time</p>
                </TabContainer>
              }
              {this.state.workoutsOpened === 1 &&
                <TabContainer
                  videoRef={'qVdSF7U9GIs'}
                  notes={'Event 2 is scored by total reps completed in the full 9 minutes. The leaderboard will display the reps and the tiebreak time, while the tool tip and user profile will also display the rounds completed.'}
                  example={'Ex: (152 reps [8:03]) and 7 Rounds + 5 FS | 152 reps [8:03]'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://www.roguefitness.com/theindex/wp-content/uploads/2019/04/Rogue-Invitational-Movement-Standards-Wod-2.pdf'}
                  logId={'2'}>
                  <h4><i className="fas fa-angle-double-right"></i>   AMRAP 9 mins:</h4>
                  <p>9 Front Squat, 135/95 lbs</p>
                  <p>7 Bar Facing Burpees</p>
                  <p>5 Shoulder to Overhead, 135/95 lbs</p>
                </TabContainer>
              }
              {this.state.workoutsOpened === 2 && 
                <TabContainer
                  videoRef={'7fbs0Dc8-Ik'}
                  notes={'Event 3 is scored by total time. However, if an athlete does not complete the workout in the 15 min time frame, the score becomes the total reps performed at that point. The leaderboard will display the reps and the tiebreak time, while the tooltip and user profile will also display the rounds completed.'}
                  example={'Ex: (162 reps [8:03]) and 3 Rounds + 6 Snatches +15 C2B Pull-ups [8:03]'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://www.roguefitness.com/theindex/wp-content/uploads/2019/04/Rogue-Invitational-Movement-Standards-Wod-3.pdf'} 
                  logId={'3'}>
                  <h4 className="mb0"><i className="fas fa-angle-double-right"></i>   For Time (cap 15 mins):</h4>
                  <p>15 Squat Snatches, 115/75 lbs</p>
                  <p>15 Chest to Bar Pull-ups</p>
                  <p>20 Box Jump Overs, 24/20 in</p>
                  <p>12 Squat Snatches, 135/95 lbs</p>
                  <p>15 Chest to Bar Pull-ups</p>
                  <p>20 Box Jump Overs, 24/20 in</p>
                  <p>9 Squat Snatches, 155/105 lbs</p>
                  <p>15 Chest to Bar Pull-ups</p>
                  <p>20 Box Jump Overs, 24/20 in</p>
                  <p>6 Squat Snatches, 185/125 lbs</p>
                  <p>15 Chest to Bar Pull-ups</p>
                  <p>20 Box Jump Overs, 24/20 in</p>
                  <p>3 Squat Snatches, 225/145 lbs</p>
                  <p>15 Chest to Bar Pull-ups</p>
                  <p>20 Box Jump Overs, 24/20 in</p>
                </TabContainer>
              }
              {this.state.workoutsOpened === 3 && 
                <TabContainer
                  videoRef={'dJShlfhTJAU'}
                  notes={'Event 4 is scored by total reps completed in the full 7 minutes. The leaderboard will display the reps and the tiebreak time, while the tool tip and user profile will also display the rounds completed.'}
                  example={'Ex: (94 reps [10:00]) and 7 Rounds + 9 DL + 1 MU  | 94 reps [10:00]'}
                  screenWidth={this.state.screenWidth}
                  refSheet={'https://www.roguefitness.com/theindex/wp-content/uploads/2019/04/Rogue-Invitational-Movement-Standards-Wod-4.pdf'}
                  logId={'4'}>
                  <h4><i className="fas fa-angle-double-right"></i>   AMRAP 7 Mins:</h4>
                  <p>9 Deadlift, 275/155 lbs</p>
                  <p>3 Ring Muscle Ups</p>
                </TabContainer>
              }
            </Grid>
            {/*<Grid
              item
              sm={5}
              xs={12}>
              <div className="white-bg pa3 mh4 mh3-s mh2-m mh0-l mt1">
                <div className="relative">
                  <div className="center">
                    <a href="https://crossfitbtwb.com" target="_blank" rel="noopener noreferrer">
                      <img alt="crossfit® btwb" src={logo} />
                    </a>
                  </div>
                  <p className="btwb-padding-top">
                    <a href="https://crossfitbtwb.com" className="no-underline" target="_blank" rel="noopener noreferrer">Leaderboard by CrossFit® btwb</a>
                  </p>
                </div>
              </div>
            </Grid>*/}
          </Grid>

        </div>
      </div>
    )
  }
}

export default WorkoutDescription;